// rokid 统一后端接口域名，设置为base url

const  ROKID_HOST_MAP = {
  local: "/rcs",
  dev: "https://rcs-dev.rokid.com",
  test: "https://rcs-test.rokid.com",
  prod: "https://rcs.rokid.com",
};
export const rokidRcsUrl = ROKID_HOST_MAP[ROKID_ENV];

const ROKID_AIPLATFORM = {
  local: "/aiPlatform",
  dev: `https://rcs-dev.rokid.com/aiPlatform`,
  test: "https://rcs-test.rokid.com/aiPlatform",
  prod: "https://rcs.rokid.com/aiPlatform",
};

export const rokidBaseUrl = ROKID_AIPLATFORM[ROKID_ENV];

// rokid agent store 域名
const ROKID_AGENT_STORE = {
  local: "/agentStore",
  dev: "https://rcs-dev.rokid.com/agentStore",
  test: "https://rcs-test.rokid.com/agentStore",
  prod: "https://rcs.rokid.com/agentStore",
};

export const rokidAgentStoreBaseUrl = ROKID_AGENT_STORE[ROKID_ENV];

// rokid 账号中心域名
const ROKID_ACCOUNT_HOST_MAP = {
  local: "https://account-web-dev.rokid.com",
  dev: "https://account-web-dev.rokid.com",
  test: "https://account-web-test.rokid.com",
  prod: "https://account-web.rokid.com",
};

export const rokidAccountBaseUrl = ROKID_ACCOUNT_HOST_MAP[ROKID_ENV];



const ROKID_METIS = {
  local: "/metis",
  dev: "https://rcs-dev.rokid.com/metis",
  test: "https://rcs-test.rokid.com/metis",
  prod: "https://rcs.rokid.com/metis",
};

export const rokidMetisBaseUrl = ROKID_METIS[ROKID_ENV];